module.exports = __webpack_public_path__ + "static/media/pointerMusic.7a71436.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/active/hjwq/springFestival/mp3/pointerMusic.mp3
// module id = qJJ8
// module chunks = 5